module.exports = __webpack_public_path__ + "img/greg_little.a93cbee6.png";